import { BaseApiResponseWithPagination, CoderProfile } from '../../types/shared.types';
import * as type from '../ActionTypes';

export function fetchCodersList(params?: any) {
  return {
    type: type.GET_CODERS_LIST,
    params: params
  };
}

export function fetchCodersListSuccess(response: BaseApiResponseWithPagination<CoderProfile>) {
  return {
    type: type.GET_CODERS_LIST_SUCCESS,
    payload: response
  };
}

export function fetchCodersListFailure(error: any) {
  return {
    type: type.GET_CODERS_LIST_FAILURE,
    payload: error
  };
}

export function clearCodersList() {
  return {
    type: type.CLEAR_CODERS_LIST
  };
}
